// extracted by mini-css-extract-plugin
export default {"modal":"Modal_modal__lbycg","wrapper":"Modal_wrapper__YOSnx","childrenWrapper":"Modal_childrenWrapper__nuFuS","close":"Modal_close__mXk-R"};